// Starts Emergent Google OAuth.
// On web: redirect straight to /chat (the SPA detects #session_id and signs in).
// In the Capacitor native app: redirect to a tiny static bridge page that forwards the
// result into the app via the custom `tuha://` URL scheme. Android App Links are unreliable
// on several OEMs (notably Xiaomi/MIUI), and the Capacitor JS bridge is not injected on
// remote-loaded pages, so MainActivity handles the tuha:// return natively.
export function isNativeApp() {
  if (typeof window === "undefined") return false;
  // Primary, bridge-independent signal: the native WebView appends "KAAYAApp" to its UA
  // (configured via capacitor.config.json -> appendUserAgent).
  const ua = (window.navigator && window.navigator.userAgent) || "";
  if (ua.indexOf("KAAYAApp") !== -1) return true;
  // Fallbacks in case the bridge is present.
  const cap = window.Capacitor;
  if (cap) {
    if (typeof cap.isNativePlatform === "function") return cap.isNativePlatform();
    if (typeof cap.getPlatform === "function") return cap.getPlatform() !== "web";
    return true;
  }
  return false;
}

export function startGoogleLogin() {
  const origin = window.location.origin;
  const redirectUrl = origin + (isNativeApp() ? "/auth-bridge.html" : "/chat");
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
